import "./styles/tailwind.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { useSelector } from "react-redux";
import { CountryProvider } from "./contexts/CountryContext";
import { LanguageProvider } from "./contexts/LanguageContext";
import MainLayout from "./layouts/MainLayout";
import { Permissions } from "./components/Auth/permissions"; 

// Pages
import SignInPage from "./pages/Auth/SignInPage";
import UnauthorizedPage from "./pages/Auth/UnauthorizedPage";
import Dashboard from "./pages/Dashboard";
import Users from "./pages/Users";
// import EditUser from "./pages/Users/edit";
import Categories from "./pages/Categories";
import Banners from "./pages/Banners";
import Auctions from "./pages/Auction";
import Clips from "./pages/Clips";
import ChannelsPage from "./pages/Channels";
import Purchases from "./pages/Purchases";
import Transactions from "./pages/Transactions";
import Withdrawals from "./pages/Withdrawals";
import Feedbacks from "./pages/Feedbacks";
import ReportAccounts from "./pages/ReportAccounts";
import Ticketing from "./pages/Ticketing";
// import Settings from "./pages/Settings";
import Reports from "./pages/Reports";
import ViewAuction from "./pages/Auction/Detail/View";
import Notifications from "./pages/Marketing/Notifications";
import Coupons from "./pages/Marketing/Coupons";
import PlanSubscriptionPage from "./pages/Subscriptions/PlanSubscriptionPage";
import PlanDetailsPage from "./pages/Settings/PlanDetailsPage";
import AdminsPage from "./pages/Admins/AdminsPage";
import AdminForm from "./pages/Admins/AdminForm";
import OrdersPage from "./pages/Orders/OrdersPage";
import CountriesPage from "./pages/Countries";
import UserDetailsPage from "./pages/Users/UserDetailsPage";
import LanguagesPage from "./pages/Languages";

// import PlanDetailsPage from "./pages/Settings/PlanDetailsPage"

// Components
import PrivateRoute from "./components/Auth/PrivateRoute";

function App() {
  const { token } = useSelector((state) => state.auth);
  console.log("Sate checking",token)

  return (
    <LanguageProvider>
    <CountryProvider>
      <Router>
        <Routes>
          {/* Redirect from root to login or dashboard */}
          <Route
            path="/"
            element={
              token ? <Navigate to="/dashboard" /> : <Navigate to="/signin" />
            }
          />

          {/* Redirect to dashboard if already logged in */}
          <Route
            path="/signin"
            element={token ? <Navigate to="/dashboard" /> : <SignInPage />}
          />
          {/* Protected Routes - Only accessible if logged in */}
          <Route element={<MainLayout />}>
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/users"
              element={
                <PrivateRoute >
                  <Users />
                </PrivateRoute>
              }
            />
            {/* <Route
              path="/users/:id"
              element={
                <PrivateRoute>
                  <EditUser />
                </PrivateRoute>
              }
            /> */}
            <Route
              path="/categories"
              element={
                <PrivateRoute requiredPermissions={Permissions.CAN_MANAGE_CATEGORIES}>
                  <Categories />
                </PrivateRoute>
              }
            />
            <Route
              path="/banners"
              element={
                <PrivateRoute requiredPermissions={Permissions.CAN_MANAGE_BANNERS}>
                  <Banners />
                </PrivateRoute>
              }
            />
            <Route
              path="/auctions"
              element={
                <PrivateRoute requiredPermissions={Permissions.CAN_MANAGE_MODULES}>
                  <Auctions />
                </PrivateRoute>
              }
            />
            <Route
              path="/auctions/:id"
              element={
                <PrivateRoute requiredPermissions={Permissions.CAN_MANAGE_MODULES}>
                  <ViewAuction />
                </PrivateRoute>
              }
            />
            <Route
              path="/clips"
              element={
                <PrivateRoute requiredPermissions={Permissions.CAN_MANAGE_MODULES}>
                  <Clips />
                </PrivateRoute>
              }
            />
            <Route
              path="/channels"
              element={
                <PrivateRoute requiredPermissions={Permissions.CAN_MANAGE_MODULES}>
                  <ChannelsPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/orders"
              element={
                <PrivateRoute requiredPermissions={Permissions.CAN_MANAGE_ORDERS}>
                  <OrdersPage/>
                </PrivateRoute>
              }
            />
            <Route
              path="/transactions"
              element={
                <PrivateRoute requiredPermissions={Permissions.CAN_MANAGE_PAYMENTS}>
                  <Transactions/>
                </PrivateRoute>
              }
            />
            <Route
              path="/withdrawals"
              element={
                <PrivateRoute requiredPermissions={Permissions.CAN_MANAGE_WITHDRAWALS}>
                  <Withdrawals/>
                </PrivateRoute>
              }
            />
            <Route
              path="/feedbacks"
              element={
                <PrivateRoute requiredPermissions={Permissions.CAN_MANAGE_FEEDBACKS}>
                  <Feedbacks />
                </PrivateRoute>
              }
            />
            <Route
              path="/ticketing"
              element={
                <PrivateRoute requiredPermissions={Permissions.CAN_MANAGE_TICKETS}>
                  <Ticketing />
                </PrivateRoute>
              }
            />
            <Route
              path="/report-accounts"
              element={
                <PrivateRoute requiredPermissions={Permissions.CAN_MANAGE_REPORTS}>
                  <ReportAccounts />
                </PrivateRoute>
              }
            />
            <Route
              path="/subscriptions"
              element={
                <PrivateRoute requiredPermissions={Permissions.CAN_MANAGE_SUBSCRIPTIONS}>
                  <PlanSubscriptionPage/>
                </PrivateRoute>
              }
            />
            <Route
              path="/reports"
              element={
                <PrivateRoute requiredPermissions={Permissions.CAN_MANAGE_REPORTS}>
                  <Reports />
                </PrivateRoute>
              }
            />
            <Route
              path="/marketing/notifications"
              element={
                <PrivateRoute requiredPermissions={Permissions.CAN_MANAGE_MARKETING}>
                  <Notifications />
                </PrivateRoute>
              }
            />
            <Route
              path="/marketing/coupons"
              element={
                <PrivateRoute requiredPermissions={Permissions.CAN_MANAGE_MARKETING}>
                  <Coupons />
                </PrivateRoute>
              }
            />
            <Route
            path="/add-plan-details"
            element={
              <PrivateRoute requiredPermissions={Permissions.CAN_MANAGE_SUBSCRIPTIONS}>
                <PlanDetailsPage />
              </PrivateRoute>
              }
            />
            <Route
              path="/admins-rights"
              element={
                <PrivateRoute requiredPermissions={Permissions.CAN_MANAGE_ADMIN}>
                  <AdminsPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/create-admin"
              element={
                <PrivateRoute requiredPermissions={Permissions.CAN_MANAGE_ADMIN}>
                  <AdminForm />
                </PrivateRoute>
              }
            />
            <Route
              path="/countries"
              element={
                <PrivateRoute requiredPermissions={Permissions.CAN_MANAGE_COUNTRIES}>
                  <CountriesPage />
                </PrivateRoute>
              }
            />
            <Route path="/users/:userId"
              element={
                <PrivateRoute requiredPermissions={Permissions.CAN_MANAGE_USERS}>
                  <UserDetailsPage/>
                </PrivateRoute>
              } 
            />
            <Route
              path="/languages"
              element={
                <PrivateRoute requiredPermissions={Permissions.CAN_MANAGE_LANGUAGES}>
                  <LanguagesPage />
                </PrivateRoute>
              }
            />
          </Route>
          <Route path="*" element={<UnauthorizedPage />} />
        </Routes>
      </Router>
    </CountryProvider>
    </LanguageProvider>
  );
}

export default App;
